import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Fun House Mirrors",
  date: new Date(2024, 1, 4),
  img: "/img/guitar-mirror.jpeg",
  video: "/videos/guitar-mirror.mp4",
  tracks: [
    {
      title: "Rodger That: The (Almost) One Year Anniversary Special",
      src: "/songs/2024-02-04/rodger_that_one_year.mp3",
      duration: 1084.296,
    },
    {
      title: "Rodger That: The Slowdown",
      src: "/songs/2024-02-04/rodger_that_the_slowdown.mp3",
      duration: 505.656,
    },
    {
      title: "The Greatest Love Story",
      src: "/songs/2024-02-04/the_greatest_love_story.mp3",
      duration: 963.912,
    },
    {
      title: "Spy Games",
      src: "/songs/2024-02-04/spy_games.mp3",
      duration: 505.056,
    },
    {
      title: "Beneficial Algae",
      src: "/songs/2024-02-04/beneficial_algae.mp3",
      duration: 759.264,
    },
    {
      title: "Feel This Vibe",
      src: "/songs/2024-02-04/feel_this_vibe.mp3",
      duration: 686.016,
    },
    {
      title: "Hold On To My Dignity",
      src: "/songs/2024-02-04/hold_onto_my_dignity.mp3",
      duration: 521.664,
    },
    {
      title: "A Solid Groove",
      src: "/songs/2024-02-04/a_solid_groove.mp3",
      duration: 719.496,
    },
    {
      title: "I'm On Youtube",
      src: "/songs/2024-02-04/im_on_youtube.mp3",
      duration: 1088.904,
    },
    {
      title: "Ode To Sinead O'Connor",
      src: "/songs/2024-02-04/ode_to_sinead.mp3",
      duration: 981.192,
    },
    {
      title: "Just Another Epic Jam",
      src: "/songs/2024-02-04/just_another_epic_jam.mp3",
      duration: 1430.832,
    },
    {
      title: "Spicy Bloomin' Onion",
      src: "/songs/2024-02-04/spicy_bloomin_onion.mp3",
      duration: 1030.68,
    },
    {
      title: "Life Force Energy",
      src: "/songs/2024-02-04/life_force_energy.mp3",
      duration: 831.264,
    },
  ],
};
export default album;
